import { Pipe, PipeTransform } from '@angular/core';
import { IdName } from '../../models';
import { enumToList } from '../enum-to-list';
import { AuditLogEvent } from '../../enums/audit-log-event.enum';

@Pipe({
  name: 'auditLogEvent',
  standalone: false
})
export class AuditLogEventPipe implements PipeTransform {
  public transform(value: AuditLogEvent): string {
    return getAuditLogEvent(value);
  }
}

export function getAuditLogEvent(value: AuditLogEvent): string {
  switch (value) {
    case AuditLogEvent.Login:
      return 'Login';
    case AuditLogEvent.Logout:
      return 'Logout';
    case AuditLogEvent.Add:
      return 'Add';
    case AuditLogEvent.Update:
      return 'Update';
    case AuditLogEvent.Delete:
      return 'Delete';
    case AuditLogEvent.Create:
      return 'Create';
    case AuditLogEvent.Submit:
      return 'Submit';
    case AuditLogEvent.Accept:
      return 'Accept';
    case AuditLogEvent.Reject:
      return 'Reject';
    case AuditLogEvent.Override:
      return 'Override';
    case AuditLogEvent.None:
      return 'None';
    case AuditLogEvent.View:
      return 'View';
    case AuditLogEvent.ReportXlsxExport:
    case AuditLogEvent.ReportPdfExport:
    case AuditLogEvent.SearchFormExport:
      return 'Export';
    case AuditLogEvent.Print:
      return 'Print';
    case AuditLogEvent.Migration:
      return 'Migration';
    default:
      throw new Error(`Unsupported value for AuditLogEvent: ${value}.`);
  }
}

export function getAuditLogEventList(): IdName[] {
  return enumToList(AuditLogEvent, getAuditLogEvent);
}
